import React, { useEffect, useState } from "react";

import "leaflet/dist/leaflet.css";
import { useSelector } from "react-redux";
import {
  MapContainer,
  Marker,
  // Polyline,
  // SVGOverlay,
  TileLayer,
  // useMap,
} from "react-leaflet";
import MapCenter from "../../containerSmall/mapCenter/MapCenter.component";
import MapCaption from "../../containerSmall/mapCaption/mapCaption.component";
import GetMapCenter from "../../components/GetMapCenter/GetMapCenter.component";
import LocationBtn from "../../components/locationBtn/locationBtn.component";
import { destIcon, startIcon } from "../../assets/img/mapMarker";
import { connect } from "react-redux";
import {
  selectNewRequestSourceLocation,
  selectNewRequestDestLocation,
  selectNewRequestSelectedProvince,
  selectNewRequestOtherDestinationsLocation,
} from "../../redux/newRequest/newRequest.selectors";
import { selectPreReqResponseInstantRequestResult } from "../../redux/preReq/preReq.selectors";
import { createStructuredSelector } from "reselect";
import {
  selectMapBottomWhiteLong,
  selectMapGoLevel4,
  selectMapLeftOverlayShow,
  selectMapLevel,
  selectMapSuggestionsShow,
} from "../../redux/map/map.selectors";
// import BottomWhite from "../../components/bottomWhite/bottomWhite.component";
import MapSuggestion from "../mapSuggestion/mapSuggestion.component";
import MapLine from "../../containerSmall/mapLine/mapLine.component";
import FllyTo from "../../components/fllyTo/fllyTo.component";
import MapBackBtn from "../../components/mapBackBtn/mapBackBtn.component";
import SourceLocationJustSet from "../../components/sourceLocationJustSet/sourceLocationJustSet.component";

import MapForwardBtn from "../../components/mapForwardBtn/mapForwardBtn.component";
import RightBalck from "../../components/rightBalck/rightBalck.component";
import SubmitReqPre from "../../containerSmall/submitReqPre/submitReqPre.component";
import { useParams } from "react-router";
import InstantReqPage from "../instantReqPage/instantReqPage.component";
import useMediaQuery from "../../hooks/useMediaQuery";

const MapCustom = ({
  selectNewRequestSourceLocation,
  selectNewRequestDestLocation,
  selectMapLevel,
  // selectNewRequestSelectedProvince,
  // selectMapBottomWhiteLong,
  selectMapSuggestionsShow,
  selectMapLeftOverlayShow,
  selectMapGoLevel4,
}) => {
  const size = useMediaQuery();

  const params = useParams();
  const res = useSelector(selectPreReqResponseInstantRequestResult);
  const otherDestinations = useSelector(
    selectNewRequestOtherDestinationsLocation
  );
  console.log("popo", otherDestinations);
  const [getCenter, setGetCenter] = useState(false);
  const [paramsId, setParamsId] = useState(params.id);

  useEffect(() => {
    if (res) setParamsId(res.load_id);
  }, [res]);

  const handleClick = () => {
    alert("first");
  };

  return (
    <div className="position-relative w-100 h-100">
      <MapContainer
        center={[35.7837, 51.4361]}
        zoom={11}
        scrollWheelZoom={true}
        zoomControl={false}
        // style={{ height: "1000px", width: "1000px" }}
        className="h-100 w-100"
        style={{ zIndex: 1 }}
      >
        <TileLayer
          //   attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
          subdomains={["mt0", "mt1", "mt2", "mt3"]}
        />
        {selectMapLevel >= 2 ? <MapLine /> : null}

        {selectMapLevel > 0 && (
          <Marker
            position={[
              selectNewRequestSourceLocation.lat,
              selectNewRequestSourceLocation.long,
            ]}
            icon={startIcon}
            eventHandlers={{
              click: () => {
                console.log("marker clicked");
              },
            }}
          />
        )}
        {selectMapLevel > 1 && (
          <Marker
            position={[
              selectNewRequestDestLocation.lat,
              selectNewRequestDestLocation.long,
            ]}
            icon={destIcon}
            eventHandlers={{
              click: () => {
                console.log("marker clicked");
              },
            }}
          />
        )}

        {selectMapLevel > 1 &&
          otherDestinations[0]?.lat &&
          otherDestinations.map((item) => (
            <Marker
              position={[item.lat, item.long]}
              icon={destIcon}
              eventHandlers={{
                click: () => {
                  console.log("marker clicked");
                },
              }}
            />
          ))}

        {!paramsId && (
          <>
            {selectMapLevel < 2 ? (
              <GetMapCenter getCenter={getCenter} setGetCenter={setGetCenter} />
            ) : null}

            <FllyTo />

            <SourceLocationJustSet />
          </>
        )}
      </MapContainer>
      {!paramsId && (
        <>
          {selectMapLevel > 0 ? <MapBackBtn /> : null}
          {/* {selectMapLevel === 2 && !selectMapGoLevel4 ? (
            <MapForwardBtn />
          ) : null} */}

          {selectMapLevel < 2 ? <MapCenter /> : null}

          {selectMapLevel < 2 ? <MapSuggestion /> : null}
          {selectMapLevel < 2 ? <MapCaption /> : null}

          {selectMapLevel < 2 ? (
            <LocationBtn setGetCenter={setGetCenter} />
          ) : null}

          {selectMapLevel === 2 && <SubmitReqPre />}
          {["xl"].includes(size) && <RightBalck />}
        </>
      )}

      {paramsId && <InstantReqPage />}

      {/* {selectMapLevel === 2 ? null : (
        <BottomWhite
          long={selectMapLeftOverlayShow || selectMapSuggestionsShow}
        />
      )} */}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestSourceLocation: selectNewRequestSourceLocation,
  selectNewRequestDestLocation: selectNewRequestDestLocation,
  selectMapLevel: selectMapLevel,

  selectNewRequestSelectedProvince: selectNewRequestSelectedProvince,
  selectMapBottomWhiteLong: selectMapBottomWhiteLong,

  selectMapSuggestionsShow: selectMapSuggestionsShow,
  selectMapLeftOverlayShow: selectMapLeftOverlayShow,

  selectMapGoLevel4: selectMapGoLevel4,
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(MapCustom);
